import { Panel, severityClasses } from "../Panel"
import type { SignalRow } from "../dashboard-types"

function fmtAge(mins: number): string {
  if (mins < 60) return `${mins}m`
  const h = Math.floor(mins / 60)
  return `${h}h`
}

export function SignalAggregator({ signals, demo }: { signals: SignalRow[]; demo?: boolean }) {
  return (
    <Panel title="Cross-Source Signal Aggregator" count={signals.length} live demo={demo}>
      <div>
        {signals.map((s, i) => {
          const sv = severityClasses(s.severity)
          return (
            <div key={s.id} className="px-3 py-2.5 border-b border-[color:var(--border)] last:border-b-0 flex items-start gap-3">
              <div className="text-[10px] text-[color:var(--text-dim)] tabular-nums w-5 pt-0.5">{i + 1}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className="text-[9px] px-1.5 py-0.5 rounded uppercase tracking-wider bg-zinc-800 text-zinc-300 tabular-nums">
                    {s.kind}
                  </span>
                  <span className={`text-[9px] px-1.5 py-0.5 rounded uppercase tracking-wider ${sv.bg} ${sv.text}`}>
                    {s.severity}
                  </span>
                  <span className="text-[10px] text-[color:var(--text-dim)] ml-auto uppercase">{s.region}</span>
                </div>
                <div className="mt-1 text-sm text-[color:var(--text)] leading-snug">{s.title}</div>
                <div className="mt-0.5 text-[10px] text-[color:var(--text-dim)] uppercase tracking-wider">
                  {fmtAge(s.age_min)} ago
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Panel>
  )
}
